export const SET_ADMISSIONS = 'Set admissions'
export const DELETE_ADMISSIONS = 'Delete admissions'
export const UPDATE_ADMISSIONS = 'Update admissions'
